import {Component, OnInit} from '@angular/core';
import {Label, MultiDataSet} from 'ng2-charts';
import {ChartType} from 'chart.js';

@Component({
  selector: 'app-company-chart',
  templateUrl: './company-chart.component.html'
})
export class CompanyChartComponent implements OnInit {
  // Doughnut
  public doughnutChartLabels: Label[] = ['Erfasste Positionen', 'Korrekturen ', 'Freigaben'];
  public doughnutChartData: MultiDataSet = [
    [0, 150, 100],
    [250, 0, 0],
  ];
  public doughnutChartType: ChartType = 'doughnut';

  constructor() { }

  ngOnInit(): void {
  }

  // events
  public chartClicked({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }

  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
  }
}
